<template>
	<div class="field-setting-box">
		<div class="form-box">
			<el-form
				:model="form"
				:rules="rules"
				ref="form"
				label-width="auto"
				style="text-align: left;"
			>
				<div class="flag-container">
					<el-form-item label="规格类型：" prop="spec">
						<el-select v-model="form.spec" placeholder="请选择规格类型">
							<el-option label="单规格商品" :value="1"></el-option>
							<el-option label="多规格商品" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<div class="flag-wrap">商品规格</div>
				</div>
				<div class="spec-box" v-if="form.spec">
					<div
						class="spec-item"
						v-for="(item, index) in form.specList"
						v-show="index === 0 || form.spec === 2"
						:key="index"
					>
						<el-form-item
							label="规格名称："
							:prop="`specList.${index}.name`"
							size="mini"
							:rules="rules.specName"
						>
							<el-input
								style="width:128px;"
								v-model="item.name"
								placeholder="请输入规格名称"
						/></el-form-item>
						<el-form-item
							label="规格值："
							:prop="`specList.${index}.value`"
							size="mini"
							:rules="rules.specValue"
						>
							<div
								class="input-wrap"
								v-for="(v, i) in item.value"
								:key="i"
								v-show="i === 0 || form.spec === 2"
							>
								<el-input
									style="width:128px;margin-right:14px;margin-bottom:8px"
									v-model="v.text"
									placeholder="请输入规格值"
								/>
								<i
									v-show="item.value.length > 1"
									class="float-btn el-icon-circle-close"
									@click="item.value.splice(i, 1)"
								/>
							</div>
							<el-button
								type="primary"
								plain
								@click="onAddSpecValueClick(index)"
								v-if="form.spec === 2"
								>增加规格值</el-button
							>
						</el-form-item>
						<i
							v-show="form.specList.length > 1"
							class="right-btn el-icon-circle-close"
							@click="onConfirmRemoveSpec(index)"
						/>
					</div>
				</div>
				<div class="spec-btns">
					<el-button
						type="primary"
						@click="onAddSpecClick"
						v-show="form.spec === 2"
						>添加规则</el-button
					>
					<el-button type="primary" @click="onGenerateSkuClick"
						>刷新重置SKU</el-button
					>
				</div>
				<div class="flag-container">
					<el-form-item label="加润百分比：" prop="supply_new_profit_percent">
						<el-input
							style="width: 350px"
							placeholder="请输入加润百分比"
							v-model="form.supply_new_profit_percent"
							type="number"
							@input="e => onProfitPercent(e)"
							@blur="e => onGetcode(e)"
						>
							<template slot="append">%</template>
						</el-input>
						<span style="color:#F56C6C;margin-left:20px"
							>商品供货价=供应链成本价*（1+加润百分比）+固定加润值</span
						>
					</el-form-item>
					<el-form-item label="验证码：" prop="goods_code" v-if="codeSwitch">
						<el-input
							style="width: 350px"
							placeholder="请输入验证码"
							v-model="form.goods_code"
							type="number"
							@input="e => onProfitPercent(e)"
						>
						</el-input>
					</el-form-item>
					<el-form-item label="固定加润值：" prop="supply_new_profit_value">
						<el-input
							style="width: 350px"
							placeholder="请输入固定加润值"
							v-model="form.supply_new_profit_value"
							type="number"
							@input="e => onProfitValue(e)"
						>
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<div class="flag-wrap">商品加润</div>
				</div>
				<div class="flag-container">
					<el-table
						:data="form.skuData"
						class="table"
						border
						style="width:100%;"
						:cell-style="tc"
						:header-cell-style="tccolor"
						ref="table"
					>
						<el-table-column label="SKU编号" width="120">
							<template slot-scope="scope">
								{{ scope.row.id || '暂无数据' }}
							</template></el-table-column
						>
						<el-table-column
							v-for="(item, index) in skuSnapData"
							:key="index"
							:label="item"
							width="120"
						>
							<template slot-scope="scope">
								{{ scope.row.attributes[index].attr_value }}
							</template></el-table-column
						>
						<el-table-column label="成本价格" width="120">
							<template slot-scope="scope">
								<el-form-item
									label-width="0"
									:prop="'skuData.' + scope.$index + '.cost_price'"
									:rules="rules.cost_price"
								>
									<el-input
										v-model="scope.row.cost_price"
										@input="e => onCostPriceChange(scope.row, e)"
										placeholder="请输入"
										type="number"
										size="mini"
										min="0"
										:disabled="readSwitch"
									/>
								</el-form-item> </template
						></el-table-column>
						<el-table-column label="供货价" width="120">
							<template slot-scope="scope">
								<el-form-item
									label-width="0"
									:prop="'skuData.' + scope.$index + '.supply_price'"
									:rules="rules.supply_price"
								>
									<el-input
										v-model="scope.row.supply_price"
										@change="e => onSupplyPriceChange(scope.row, e)"
										placeholder="请输入"
										type="number"
										size="mini"
										readonly
										min="0"
								/></el-form-item> </template
						></el-table-column>
						<el-table-column label="建议售价" width="120">
							<template slot-scope="scope">
								<el-form-item
									label-width="0"
									:prop="'skuData.' + scope.$index + '.sale_price'"
									:rules="rules.sale_price"
								>
									<el-input
										v-model="scope.row.sale_price"
										placeholder="请输入"
										type="number"
										size="mini"
										min="0"
								/></el-form-item> </template
						></el-table-column>
						<el-table-column label="库存数" width="120">
							<template slot-scope="scope">
								<el-form-item label-width="0">
									<el-input
										v-model="scope.row.inventory"
										placeholder="请输入"
										type="number"
										size="mini"
										min="0"
								/></el-form-item> </template
						></el-table-column>
						<el-table-column label="虚拟销量" width="120">
							<template slot-scope="scope">
								<el-form-item label-width="0">
									<el-input
										v-model="scope.row.sale_volume_v"
										placeholder="请输入"
										type="number"
										size="mini"
										min="0"
									/> </el-form-item></template
						></el-table-column>
						<el-table-column label="SKU图片" width="120">
							<template slot-scope="scope">
								<UploadImg
									flieName="img_url"
									class="upload_img"
									:oldImgs="[scope.row.img_url]"
									:n="1"
									@getFile="e => getSkuFile(scope.row, e)"
								></UploadImg> </template
						></el-table-column>
						<el-table-column label="操作" width="160">
							<template slot-scope="scope">
								<el-switch
									v-model="scope.row.status"
									active-text="启用"
									inactive-text="禁用"
									:active-value="0"
									:inactive-value="1"
								>
								</el-switch> </template
						></el-table-column>
					</el-table>
					<div class="flag-wrap">SKU设置</div>
				</div>
				<div class="flag-container">
					<el-form-item label="商品主图：" prop="image"
						><UploadImg
							:oldImgs="form.image"
							flieName="mainImage"
							:n="1"
							:folder="
								this.$route.query.id ? this.$route.query.id : this.getDate()
							"
							@getFile="getFile"
						/>
					</el-form-item>
					<el-form-item label="轮播图：">
						<UploadImg
							:oldImgs="form.images"
							flieName="banner"
							:n="9"
							:folder="
								this.$route.query.id ? this.$route.query.id : this.getDate()
							"
							@getFile="getFile"
						/>
					</el-form-item>
					<div class="flag-wrap">商品相册</div>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
/**
 * @on-success
 */
import UploadImg from '@/components/uploadImg'
import { getOnSalePrice, getSupplyPrice, checkGarunAtio } from '@/api/goods'
export default {
	components: { UploadImg },
	props: {
		goodsData: {},
		formData: {}
	},
	watch: {
		goodsData(v) {
			this.form.spec = v.sku.length > 1 ? 2 : 1
			this.form.supply_new_profit_percent = v.supply_new_profit_percent
			this.form.supply_new_profit_value = v.supply_new_profit_value
			this.form.image = [v.img_url]
			this.form.images = v.images.map(item => item.img_url)
			// 生成sku规则
			const specArray = []
			const skuData = []
			v.sku.forEach(item => {
				item.product_sku_attribute.forEach(attr => {
					//是否有这个规则
					const arrayItem = specArray.find(
						arrayItem => arrayItem.name === attr.attr_name
					)
					if (arrayItem) {
						//是否有这个值
						const valueItem = arrayItem.value.find(
							valueItem => valueItem.text === attr.attr_value
						)
						if (!valueItem) {
							arrayItem.value.push({ text: attr.attr_value })
						}
					} else {
						specArray.push({
							name: attr.attr_name,
							value: [{ text: attr.attr_value }]
						})
					}
				})
				//
				skuData.push({
					id: item.id,
					cost_price: item.cost_price,
					supply_price: item.supply_price,
					sale_price: item.sale_price,
					inventory: item.inventory,
					sale_volume_v: item.sale_volume_v,
					img_url: item.set_img_url,
					status: item.status,
					attributes: item.product_sku_attribute
				})
				this.skuSnapData = specArray
					.filter(item => item.name)
					.map(item => item.name)
			})
			this.form.specList = specArray
			this.form.skuData = skuData
			if (v.supplier_id > 0) {
				this.readSwitch = true
			}
		}
	},
	data() {
		return {
			readSwitch: false,
			form: {
				spec: '',
				specList: [
					{
						name: '',
						value: [{ text: '' }]
					}
				],
				image: [],
				images: [],
				skuData: [],
				supply_new_profit_percent: '',
				goods_code: '',
				supply_new_profit_value: ''
			},
			rules: {
				spec: [
					{
						required: true,
						trigger: 'blur',
						message: '请选择规格类型'
					}
				],
				specName: [
					{ required: true, trigger: 'blur', message: '请输入规格名称' }
				],
				supply_new_profit_percent: [
					{ required: true, trigger: 'blur', message: '请输入加润百分比' }
				],
				goods_code: [
					{ required: true, trigger: 'blur', message: '请输入验证码' }
				],
				supply_new_profit_value: [
					{ required: true, trigger: 'blur', message: '请输入加润固定值' }
				],
				specValue: [
					{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							const emptyIndex = value.findIndex(item => !item.text)

							if (emptyIndex === -1) {
								callback()
							} else {
								callback(new Error('请输入规格值'))
							}
						}
					}
				],
				image: [
					{
						required: true,
						trigger: 'blur',
						message: '请上传商品主图'
					}
				],
				cost_price: [
					{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (Number(value || '')) {
								callback()
							} else {
								callback(new Error('请输入成本价格'))
							}
						}
					}
				],
				supply_price: [
					{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (Number(value || '')) {
								callback()
							} else {
								callback(new Error('请输入供货价'))
							}
						}
					}
				],
				sale_price: [
					{
						required: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (Number(value || '')) {
								callback()
							} else {
								callback(new Error('请输入建议售价'))
							}
						}
					}
				]
			},
			skuSnapData: [],
			resData: [],
			onSalePriceData: null,
			supplyPriceData: null,
			folder: '',
			codeSwitch: false
		}
	},
	created() {
		this.initPrice()
	},
	methods: {
		getDate() {
			const date = new Date()
			return `${date.getFullYear()}${
				date.getMonth() > 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
			}${date.getDate() > 9 ? date.getDate() : '0' + date.getDate()}`
		},
		initPrice() {
			getOnSalePrice().then(res => {
				this.onSalePriceData = res
			})
			getSupplyPrice().then(res => {
				this.supplyPriceData = res
			})
			getSupplyPrice().then(res => {
				this.prData = res
				this.form.supply_add_profit_percent = res.supply_add_profit_percent
				this.form.supply_add_profit_value = res.supply_add_profit_value
			})
		},
		clearForm() {
			this.$refs.form.resetFields()
			this.form.specList = [
				{
					name: '',
					value: [{ text: '' }]
				}
			]
			this.form.skuData = []
			this.skuSnapData = []
		},
		checkForm() {
			console.log(this.form)
			if (!this.form.skuData.length) {
				this.generateSku()
			}
			this.$nextTick(() => {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.$emit('update:formData', {
							image: this.form.image[0],
							images: JSON.stringify(this.form.images),
							sku: JSON.stringify(this.form.skuData),
							supply_new_profit_percent: this.form.supply_new_profit_percent,
							goods_code: this.form.goods_code,
							supply_new_profit_value: this.form.supply_new_profit_value
						})
						this.$emit('on-success')
					} else {
						return false
					}
				})
			})
		},
		onAddSpecClick() {
			this.form.specList.push({
				name: '',
				value: [{ text: '' }]
			})
		},
		onConfirmRemoveSpec(index) {
			this.$confirm('删除会重置规格明细，确认删除？', '操作确认', {
				confirmButtonText: '确定',
				type: 'warning'
			}).then(() => {
				this.form.specList.splice(index, 1)
				this.generateSku()
			})
		},
		//生成sku
		onGenerateSkuClick() {
			// this.$refs.form.validate(valid => {
			// 	if (valid) {
			this.$confirm('重置刷新会覆盖现有列表，是否继续？', '操作确认', {
				confirmButtonText: '确定',
				type: 'warning'
			}).then(() => {
				this.generateSku()
			})
			// 	} else {
			// 		return false
			// 	}
			// })
		},
		generateSku() {
			// 生成规则名称数组
			if (this.form.spec === 2) {
				//多规格
				this.skuSnapData = this.form.specList
					.filter(item => item.name)
					.map(item => item.name)
			} else {
				this.skuSnapData = this.form.specList[0].name
					? [this.form.specList[0].name]
					: []
			}
			this.form.skuData = []
			if (this.form.spec === 2) {
				//多规格
				let multiArray = []
				this.form.specList.forEach(item => {
					if (item.name) {
						multiArray.push(item.value)
					}
				})

				multiArray = this.cartesianProduct(multiArray)
				multiArray.forEach((_, index) => {
					const d = {
						cost_price: 0,
						supply_price: 0,
						sale_price: 0,
						inventory: 0,
						sale_volume_v: 0,
						img_url: '',
						status: 0,
						attributes: []
					}
					multiArray[index].forEach((v, i) => {
						d.attributes.push({
							attr_name: this.skuSnapData[i],
							attr_value: v.text
						})
					})
					this.form.skuData.push(d)
				})
			} else {
				this.form.skuData.push({
					cost_price: 0,
					supply_price: 0,
					sale_price: 0,
					inventory: 0,
					sale_volume_v: 0,
					img_url: '',
					status: 0,
					attributes: [
						{
							attr_name: this.form.specList[0].name,
							attr_value: this.form.specList[0].value[0].text
						}
					]
				})
			}
		},
		onAddSpecValueClick(index) {
			if (this.form.specList[index].value.length >= 10) {
				this.$message.error('最多支持添加10个规格值')
				return
			}
			this.form.specList[index].value.push({ text: '' })
		},
		onProfitPercent(e) {
			let formData = this.form.skuData
			for (let i = 0; i < formData.length; i++) {
				const p =
					((formData[i].cost_price || 0) * (100 + Number(e))) / 100 +
					Number(this.form.supply_new_profit_value)
				formData[i].supply_price = p.toFixed(2)
			}
		},
		onGetcode() {
			const { supply_new_profit_percent } = this.form
			console.log(this.form.supply_new_profit_percent)
			if (supply_new_profit_percent) {
				checkGarunAtio({
					add_profit_value: supply_new_profit_percent,
					id: this.$route.query.id
				})
					.then(() => {
						this.codeSwitch = false
					})
					.catch(() => {
						this.codeSwitch = true
					})
			}
		},
		onProfitValue(e) {
			let formData = this.form.skuData
			for (let i = 0; i < formData.length; i++) {
				const p =
					((formData[i].cost_price || 0) *
						(100 + Number(this.form.supply_new_profit_percent))) /
						100 +
					Number(e)
				formData[i].supply_price = p.toFixed(2)
			}
		},
		onCostPriceChange(item, e) {
			console.log(this.form.supply_new_profit_value)
			// const p =
			// 	((Number(e) || 0) *
			// 		(100 + Number(this.supplyPriceData.supply_add_profit_percent))) /
			// 		100 +
			// 	Number(this.supplyPriceData.supply_add_profit_value)
			// item.supply_price = p.toFixed(2)
			// this.onSupplyPriceChange(item, e)
			const p =
				((Number(e) || 0) *
					(100 + Number(this.form.supply_new_profit_percent))) /
					100 +
				Number(this.form.supply_new_profit_value)
			item.supply_price = p.toFixed(2)
			this.onSupplyPriceChange(item, e)
		},
		onSupplyPriceChange(item, e) {
			item.sale_price = (
				((Number(e) || 0) *
					(100 + Number(this.onSalePriceData.sale_add_profit_percent))) /
					100 +
				Number(this.onSalePriceData.sale_add_profit_value)
			).toFixed(2)
		},
		getSkuFile(item, file) {
			item[file.name] = file.files.length > 0 ? file.files[0].url : ''
			return
		},
		getFile(file) {
			if (file.name === 'mainImage') {
				this.form.image = file.files.map(obj => {
					return obj.url
				})
				return
			}
			if (file.name === 'banner') {
				this.form.images = file.files.map(obj => {
					return obj.url
				})
			}
		},
		tc() {
			return 'text-align:center; color:#333333; font-size:12px;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		},
		cartesianProduct(arr) {
			return arr.reduce(
				(a, b) =>
					a.map(x => b.map(y => x.concat(y))).reduce((a, b) => a.concat(b), []),
				[[]]
			)
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.field-setting-box {
	border: 1px solid #ddd;
	width: 1500px;
	background-color: #fcfcfc;
	margin: 0 auto;
	padding-left: 180px;
	.flag-container {
		position: relative;
		.flag-wrap {
			$h: 48px;
			width: 180px;
			height: $h;
			background-color: #9ea7b4;
			position: absolute;
			left: -271px;
			top: 0;
			color: #fff;
			font-size: 16px;
			display: flex;
			align-items: center;
			padding-left: 42px;
			&::before {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				border-top: 12px solid #fff;
				border-bottom: 6px solid transparent;
				border-left: 8px solid #fff;
				border-right: 8px solid #fff;
				top: 50%;
				transform: translateY(-50%);
				left: 20px;
			}
			&::after {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				top: 0;
				right: -$h/3;
				border-top: $h/2 solid transparent;
				border-bottom: $h/2 solid transparent;
				border-left: $h/3 solid #9ea7b4;
			}
		}
	}

	.form-box {
		border-left: 1px solid #ddd;
		background-color: #fff;
		padding-left: 90px;
		padding-top: 40px;
		padding-right: 128px;
		.spec-box {
			border: 1px solid #ddd;
			background-color: #f9fafc;
			.spec-item {
				padding: 20px 90px 0 20px;
				position: relative;
				overflow: hidden;
				&:not(:last-child) {
					border-bottom: 1px solid #ddd;
				}
				.right-btn {
					position: absolute;
					right: 24px;
					top: 50%;
					transform: translateY(-50%);
					font-size: 28px;
				}
			}
		}
		.input-wrap {
			position: relative;
			display: inline-block;
			.float-btn {
				position: absolute;
				right: 10px;
				top: -4px;
				font-size: 16px;
			}
		}
		.spec-btns {
			margin-top: 10px;
			margin-bottom: 50px;
		}
		.table {
			margin-top: 60px;
			margin-bottom: 30px;
		}
	}
}
</style>
